import { UserSagaWatcher } from './services/saga';

export const mainModuleSaga = [UserSagaWatcher];
